"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotificationEntity = void 0;
const AlertNotificationDto_1 = require("./AlertNotificationDto");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const UserDto_1 = require("../users/UserDto");
const UserEntity_1 = require("../users/UserEntity");
class AlertNotificationEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, alertNotification) {
        super();
        this._requiredFieldsSetStatus = {
            userId: false,
            text: false
        };
        this._dependencies = dependencies;
        if (alertNotification === undefined) {
            this._dto = new AlertNotificationDto_1.AlertNotificationDto();
        }
        else if (alertNotification instanceof AlertNotificationDto_1.AlertNotificationDto) {
            this._dto = new AlertNotificationDto_1.AlertNotificationDto(alertNotification);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (alertNotification instanceof AlertNotificationEntity) {
            this._dto = new AlertNotificationDto_1.AlertNotificationDto(alertNotification._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AlertNotificationDto_1.AlertNotificationDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getAlertId() {
        return this._dto.alertId;
    }
    getUser() {
        if (this._dto.userId === undefined) {
            return undefined;
        }
        if (this._dto.user === undefined) {
            throw new Error("Cannot call getUser without " +
                "first loading the User.");
        }
        if (!this._userEntity && this._dto.user) {
            this._userEntity = new UserEntity_1.UserEntity(this._dependencies, this._dto.user);
        }
        return this._userEntity;
    }
    getUserId() {
        return this._dto.userId;
    }
    setUser(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof UserEntity_1.UserEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof UserDto_1.UserDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setUserId(untrustedId);
        if (this.hasError("userId")) {
            return;
        }
        if (untrustedValue instanceof UserEntity_1.UserEntity) {
            this._userEntity = untrustedValue;
        }
    }
    setUserId(untrustedValue) {
        let _untrustedValue;
        this.clearError("userId");
        this._requiredFieldsSetStatus.userId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("userId", "User Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("userId", "User is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.userId) {
            return;
        }
        this._dto.userId = _untrustedValue;
        delete this._userEntity;
        this._setIsDirty(true);
    }
    getText() {
        return this._dto.text;
    }
    setText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("text");
        this._requiredFieldsSetStatus.text = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("text", "Text is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("text", `Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.text) {
            return;
        }
        this._dto.text = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadUserAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getUserId()) {
                    return;
                }
                this._emit("before-loadUserAsync");
                this._dto.user = yield this._dependencies.userDatastore
                    .getAsync(this.getUserId(), expand);
                delete this._userEntity;
                this._emit("after-loadUserAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.alertNotificationDatastore
                    .getAsync(id, expand);
                delete this._userEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Alert Notification is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.alertNotificationDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.alertNotificationDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Alert Notification cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.alertNotificationDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AlertNotificationEntity = AlertNotificationEntity;
//# sourceMappingURL=AlertNotificationEntity.js.map